import { render } from "./ButtonArrow.vue?vue&type=template&id=8341d034&scoped=true&ts=true"
import script from "./ButtonArrow.vue?vue&type=script&lang=ts"
export * from "./ButtonArrow.vue?vue&type=script&lang=ts"

import "./ButtonArrow.vue?vue&type=style&index=0&id=8341d034&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8341d034"]])

export default __exports__